<template>
  <!-- Item của combo không có column -->
  <li v-if="comboType === 1" class="combobox-item single" :style="'text-align: ' + align">
    <div v-if="isCheckMultiple" class="cell-checkbox mr-2">
      <div class="icon" :class="{checked: isSelected}" />
    </div>

    <div class="combobox-item-con">
      <!-- sửa lại title để lấy tooltip ko bị viết tắt (thêm 1 trường 'tooltip' vào item ở các component tương ứng) -->
      <!-- modified by: vqphong - 06/10/2022 -->
      <div v-if="formatType != $ms.constant.FormatType.ComboboxImage" class="combobox-item--text" :title="item.tooltip || getItemDisplay(item)">
        <template v-if="item[logoField]">
          <img :src="item[logoField]" class="combobox-item-logo" alt="logo" />
        </template>
        {{ getItemDisplay(item) }}
      </div>
      <!-- dạng hình ảnh -->

      <div v-else class="combobox-item--text combobox-item--image">
        <!-- <img :src="getItemDisplay(item)" class="img-bg"> -->
        <div :class="[getItemDisplay(item)]" class="item-img"></div>
      </div>
    </div>
  </li>
  <li
    v-else-if="comboType === 3 && columnx.length == 0"
    class="combobox-item single"
    :class="{parent: item.isParent}"
    :style="'text-align: ' + align"
    v-on="listeners"
  >
    <div class="combobox-item-con">
      <div v-if="isCheckMultiple" class="cell-checkbox mr-2">
        <div class="icon" :class="{checked: isSelected}" />
      </div>
      <div class="combobox-item--text" :class="`level-${item.level}`" :title="getItemDisplay(item)">
        {{ getItemDisplay(item) }}
      </div>
    </div>
    <!-- <div class="selected-container" v-if="item.multiSelected || isSelected">
      <div :class="['icon24', 'mi-checkbox-active']"></div>
    </div> -->
  </li>
  <tr v-else class="combobox-item" :class="{parent: item.isParent}">
    <!-- Item của combo có column -->
    <td v-if="isCheckMultiple">
      <div class="cell-checkbox-combobox">
        <div class="icon" :class="{checked: isSelected}" />
      </div>
    </td>
    <td
      v-for="(column, tdIndex) in columnx"
      :ref="`td-${tdIndex}`"
      :key="column.dataField"
      class="combobox-item-td"
      :class="comboType === 3 && tdIndex === 0 ? `level-${item.level}` : null"
    >
      <div class="combobox-item-td--contents" :style="getCellStyle(column, tdIndex)">
        <div :title="getItemDisplay(item, column)" class="combobox-item-td--text">
          <template v-if="column.formatType == $ms.constant.FormatType.Checkbox">
            <span class="cell-checkbox">
              <div class="icon" :class="{checked: item[column.dataField]}" />
            </span>
          </template>
          <template v-else>
            {{ getItemDisplay(item, column) }}
          </template>
        </div>
      </div>
    </td>
    <!-- <td class="selected-container">
      <div
        :class="['icon24', 'mi-checkbox-active']"
        v-if="item.multiSelected || isSelected"
      ></div>
    </td> -->
  </tr>
</template>

<script>
import {defineComponent, getCurrentInstance} from 'vue';
export default defineComponent({
  name: 'MsComboBoxItem',
  props: {
    /**
     * Loại combo
     */
    comboType: {
      type: Number,
      default: 1,
    },
    /**
     * Item sử dụng để binding
     */
    item: {},

    /**
     * Cấu hình cột của menu
     */
    columnx: {
      type: Array,
      default: new Array(),
    },
    /**
     * Trường làm value
     * CreatedBy PDKIEN 10/12/2019
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường là display
     * CreatedBy PDKIEN 10/12/2019
     */
    displayField: {
      type: String,
      default: null,
    },

    /**
     * Trường chứa đường dẫn logo
     */
    logoField: {
      type: String,
      default: 'logo_url',
    },

    /**
     * Trạng thái có btn `Xóa` trong item
     */
    hasRemoveItemButton: {
      type: Boolean,
      default: false,
    },
    /**
     * Kiểu định dạng dữ liệu trên combobox
     * Tương ứng với FormatType
     * CreatedBy PDKIEN 07/12/2019
     */
    formatType: {
      type: [Number, String],
      default: null,
    },
    align: {
      type: String,
      default: 'left',
    },
    /**
     * có đang được chọn hay không
     */
    isSelected: {
      type: Boolean,
      default: false,
    },
    isCheckMultiple: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    // Variable
    const {proxy} = getCurrentInstance();

    // Method
    /**
     * Hàm lấy style cho td trong table
     * dữ liệu động theo config của dev
     */
    const getCellStyle = (column, index) => {
      if (column.isResize) {
        if (proxy.$refs[`td-${index}`] && proxy.$refs[`td-${index}`].length > 0) {
          const item = proxy.$refs[`td-${index}`][0];
          const rectTd = item.getBoundingClientRect();
          const rectParent = proxy.$parent.$el.getBoundingClientRect();
          if (rectTd.right <= rectParent.right) {
            return {
              width: rectTd.width + (rectParent.right - rectTd.right) + 'px',
              textAlign: column.columnAlign,
            };
          } else {
            return {
              width: `${column.width}px`,
              textAlign: column.columnAlign,
            };
          }
        }
      }
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.columnAlign,
      };
    };

    /**
     * Lấy text hiển thị trên item
     * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
     * CreatedBy PDKIEN 10/12/2019
     * NNLINH 05.07.2022 Add FormatTypeColumn
     */
    const getItemDisplay = (item, column) => {
      const field = column ? column.dataField : props.displayField || props.valueField;

      let value = '';
      if (field) {
        value = item[field];
      } else {
        value = item;
      }

      if (column && column.formatType) {
        switch (column.formatType) {
          case proxy.$ms.constant.FormatType.Date:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
              });
            }
            break;
          case proxy.$ms.constant.FormatType.Enum:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
                enumName: column.enum,
              });
            }
            break;
          case proxy.$ms.constant.FormatType.Checkbox:
            value = value ? proxy.$t('i18nComponent.BooleanValue.True') : proxy.$t('i18nComponent.BooleanValue.False');
            break;
          case proxy.$ms.constant.FormatType.Amount:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
              });
            }
            break;
          default:
            break;
        }
      }
      return value;
    };

    /**
     * Xử lý sự kiện khi click icon xóa item
     */
    const onRemoveItemClick = e => {
      emit('removeItem', e);
    };

    return {
      getCellStyle,
      getItemDisplay,
      onRemoveItemClick,
    };
  },
});
</script>

<style lang="scss">
@import '@/assets/scss/components/MsComboboxItem.scss';

</style>
